import React, { useState } from "react";
import View from "./View";
import { Container, Stack, Typography } from "@mui/material";
import FileCard from "components/files/FileCard";
import { useDispatch, useSelector } from "react-redux";
import { fonts } from "fonts";
import UploadFileModal from "components/files/UploadFileModal";
import Loader from "components/react-lib/generic-ui/Loader";
import { useTheme } from "@emotion/react";
import ImageUploaderIconButton from "components/images/ImageUploaderIconButton";
import ImagePreview from "../components/images/ImagePreview";
import AIMenuGenerator from "../ai-menu/AIMenuGenerator";

export default function GenerateAIMenuView() {
  const theme = useTheme();

  const [image, setImage] = useState();
  const [uploading, setUploading] = useState(false);

  const uploadImage = async () => {
    try {

    } catch(error) {
      console.log(error);
    } finally {

    }
  }

  const handleSelectImage = (image) => {
    setImage(image);
    uploadImage();
  };

  const renderContent = () => {
    if (!image) {
      return <ImageUploaderIconButton addImage={handleSelectImage} />;
    }
    return <AIMenuGenerator image={image} setImage={setImage} />;
  };

  return (
    <View
      renderLeftActions={() => (
        <Typography
          fontFamily={fonts.anton}
          sx={{
            color: theme.palette.text.main,
          }}
        >
          AI Menu
        </Typography>
      )}
    >
      <Container maxWidth="md">
        <Stack>{renderContent()}</Stack>
      </Container>
    </View>
  );
}
